import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Login } from '../common/components/Login'
import { LoginCustom } from './LoginCustom';
import { AppHelper } from '../helpers/AppHelper';
export class LoginPage extends Component {
  render() {
    return (
      <LoginCustom
        loginPanelStyle={Styles.loginPanel}
        showTerms={!AppHelper.isOohConsoleHost()}>
      </LoginCustom>)
  }
}
const Styles = StyleSheet.create({
  loginPanel: {
    display: 'flex',
    flexDirection: 'column',
    //alignItems: 'flex-start',
    justifyContent: 'center',
    flex: 1
  },
})



// WEBPACK FOOTER //
// ./src/screens/LoginPage.js